module.exports = __webpack_public_path__ + "static/favicon-72441a8f8ad463255cefd0903f576452.ico";